export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_22-EN-302c7b335fbe78a46ebc69755c90653d.webp";